// Class: openfl.display.GraphicsEndFill

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
function openfl_display_IGraphicsFill() {return require("./../../openfl/display/IGraphicsFill");}
function openfl_display_IGraphicsData() {return require("./../../openfl/display/IGraphicsData");}

// Constructor

var GraphicsEndFill = function() {
	this.__graphicsDataType = 5;
	this.__graphicsFillType = 3;
}

// Meta

GraphicsEndFill.__name__ = "openfl.display.GraphicsEndFill";
GraphicsEndFill.__isInterface__ = false;
GraphicsEndFill.__interfaces__ = [(openfl_display_IGraphicsFill().default),(openfl_display_IGraphicsData().default)];
GraphicsEndFill.prototype = {
	
};
GraphicsEndFill.prototype.__class__ = GraphicsEndFill.prototype.constructor = $hxClasses["openfl.display.GraphicsEndFill"] = GraphicsEndFill;

// Init



// Statics




// Export

exports.default = GraphicsEndFill;